if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        // Auf der Warenkorbseite oeffnet ein Knopf AUSSERHALB der Schublade
        // keinen Dialog (die Seite zieht nach, window.ApCartAdd.kauf).
        const aufWarenkorbseite = !!document.getElementById('main-cart-items') && !this.closest('cart-drawer');
        if (document.querySelector('cart-drawer') && !aufWarenkorbseite) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      /*
       * ABWEICHUNG VON DAWN (26.09.2026, Betreiber: "einige Warenkorb-Buttons:
       * Sidebar oeffnet nicht, keine Fehlermeldung, nix"). Der Klick laeuft
       * ueber den EINEN Warenkorb-Pfad des Themes, window.ApCartAdd.kauf
       * (assets/automotive.js) — derselbe wie Sticky-Leiste, Satzpreis,
       * Staffelpreise und "Zusammen in den Warenkorb". Dawns eigene Auswertung
       * liess hier fuenf Faelle stumm enden (live nachgestellt):
       *   - Netzfehler, 429-Pruefseite, 500: `response.json()` warf auf HTML,
       *     der catch schrieb nur in die Konsole;
       *   - 422 an Kachel, Montagecheck, "Passend dazu", Zubehoer: keine
       *     Fehlerzeile im Markup -> nichts sichtbar;
       *   - 422 an der Kachel schaltete den Knopf auf "AUSVERKAUFT" und hielt
       *     ihn bis zum Neuladen gesperrt (this.error) — auch wenn nur der
       *     Korb schon alles enthielt oder Shopify eine Teilmenge ablegte;
       *   - Teilmenge / Korb voll: die Schublade ging nie auf.
       * Jetzt endet jeder Klick in genau einem Zustand (Vertrag im Kopf von
       * ApCartAdd): Schublade bei Erfolg, Teilmenge und vollem Korb (mit
       * Hinweis), Meldung am Knopf bei echtem Fehler, Knopf danach frei.
       *
       * Ohne den gemeinsamen Pfad (automotive.js nicht geladen) bleibt es beim
       * normalen Formular: Shopify legt ab und zeigt /cart — nie stumm.
       */
      onSubmitHandler(evt) {
        const kasse = window.ApCartAdd;
        if (!kasse || typeof kasse.kauf !== 'function') return;
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const formData = new FormData(this.form);
        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);
        const quickAddModal = this.closest('quick-add-modal');
        // Mindestmenge der Variante: steht das Mengenfeld auf 0, der Korb ist
        // aber leer (anderswo geleert, Zurueck-Taste), legt der gemeinsame Pfad
        // diese Menge ab statt "nicht verfuegbar" zu melden.
        const mengenFeld = this.form.elements && this.form.elements.namedItem('quantity');
        const mindest = mengenFeld && mengenFeld.getAttribute ? parseInt(mengenFeld.getAttribute('data-min') || mengenFeld.getAttribute('min') || '', 10) : NaN;

        kasse
          .kauf({
            knopf: this.submitButton,
            host: this,
            anfrage: formData,
            quelle: 'product-form',
            variantId: variantId,
            mindestMenge: mindest > 0 ? mindest : 1,
            aktiv: document.activeElement,
            meldung: (text, art) => this.handleErrorMessage(text, art),
            // Aus dem Schnellkauf-Dialog heraus erst den Dialog schliessen,
            // dann die Schublade zeichnen (Dawn: modalClosed abwarten).
            vorSchublade: quickAddModal
              ? () =>
                  new Promise((resolve) => {
                    document.body.addEventListener('modalClosed', () => setTimeout(resolve), { once: true });
                    quickAddModal.hide(true);
                  })
              : null,
          })
          .then((ergebnis) => {
            const status = ergebnis && ergebnis.status;
            // Cloudflare-Pruefung: die Seite navigiert gleich als normales
            // Formular weiter — kein Fehler, nichts zu melden.
            if (status === 'pruefung') return;
            if (status === 'ok' || status === 'teil') {
              // Der Korb hat sich geaendert (bei 'teil' um die lieferbare Menge).
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              return;
            }
            const grund = (ergebnis && (ergebnis.grund || ergebnis.meldung)) || 'Cart error';
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: grund,
                message: ergebnis && ergebnis.meldung,
              });
            }
            this.dispatchCartErrorEvent(grund, status === 'netz' ? 'SERVICE_UNAVAILABLE' : 'INVALID');
            linesUpdateDeferred?.reject(new Error(grund));
          })
          .catch((e) => console.error(e))
          .finally(() => {
            if (typeof CartPerformance !== 'undefined') CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      // Meldung am Knopf. Die Kaufkarte der Produktseite hat Dawns Fehlerzeile
      // (snippets/buy-buttons.liquid, role=alert); Kachel, Montagecheck,
      // "Passend dazu" und Zubehoer haben keine — dort legt der gemeinsame Pfad
      // die Zeile beim ersten Text an (ApCartAdd.meldung). Leerer Text raeumt ab.
      handleErrorMessage(errorMessage = false, art) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) {
          if (window.ApCartAdd && typeof window.ApCartAdd.meldung === 'function') {
            window.ApCartAdd.meldung(this, errorMessage || '', art);
          }
          return;
        }
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          // Die Zeile steht UNTER dem Kaufknopf (snippets/buy-buttons.liquid,
          // damit der Knopf nicht springt) — liegt sie ausserhalb des Bilds,
          // hineinholen; 'nearest' bewegt nichts, wenn sie schon zu sehen ist.
          if (typeof this.errorMessageWrapper.scrollIntoView === 'function') {
            try {
              this.errorMessageWrapper.scrollIntoView({ block: 'nearest' });
            } catch (e) {
              /* aeltere Browser */
            }
          }
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
